var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4l1.572 4.837h5.085l-4.114 2.99 1.572 4.836L10 13.673l-4.114 2.99 1.571-4.837-4.114-2.99h5.085L10 4z",
    stroke: "#9A9CAC",
    strokeWidth: 2
  })));
}

export default SvgVipIcon;